import { fetchApiData } from "#/src/hooks/api/fetcherDefaults";
import { useQuery } from "@web-monorepo/fetchers";
import { paths } from "@web-monorepo/api-types";

type Endpoint = paths["/api/marketplace/parent/session-discount"]["get"];
type Response = Endpoint["responses"]["200"]["content"]["application/json"];

export type PromotionType = Response[number]["promotionType"];

export type SessionDiscount = Response[number];

export const SESSION_DISCOUNTS_QUERY_KEY = ["getSessionDiscounts"] as const;

const SESSION_DISCOUNTS_PATH = "/api/marketplace/parent/session-discount";

const getSessionDiscounts = () =>
  fetchApiData<Response>({ method: "GET", path: SESSION_DISCOUNTS_PATH, route: SESSION_DISCOUNTS_PATH });

export default (options?: { enabled?: boolean; userId?: string }) => {
  return useQuery(
    options?.userId ? [...SESSION_DISCOUNTS_QUERY_KEY, options.userId] : SESSION_DISCOUNTS_QUERY_KEY,
    getSessionDiscounts,
    {
      refetchOnWindowFocus: options?.userId ? "always" : false,
      ...(options?.userId ? { onError: () => undefined } : {}),
      meta: { silentNetworkError: Boolean(options?.userId) },
      refetchOnMount: false,
      enabled: options?.enabled ?? true,
    },
  );
};
